const sliderStepInit = (block) => {
    const sliders = block
        ? [block[0].querySelector('.bn-slider-step .bn-slider-step__swiper')]
        : Array.from(document.querySelectorAll('.bn-slider-step .bn-slider-step__swiper'));

    if (sliders) {
        sliders.forEach((slider) => {
            if (slider) {
                const wrapper = slider.closest('.bn-slider-step');
                const navEl = wrapper.querySelector('.bn-slider-step__nav');
                const realSlideCount = slider.querySelectorAll('.swiper-slide').length;
                const hasMultipleSlides = realSlideCount > 1;

                if (navEl) {
                    navEl.hidden = !hasMultipleSlides;
                }

                const sliderConfig = {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    centeredSlides: true,
                    rewind: hasMultipleSlides,
                    navigation: {
                        nextEl: wrapper.querySelector('.bn-slider-step__btn--next'),
                        prevEl: wrapper.querySelector('.bn-slider-step__btn--prev'),
                    },
                };

                new Swiper(slider, sliderConfig);
            }
        });
    }
};

document.addEventListener('DOMContentLoaded', function () {
    if (
        !document.body.classList.contains('block-editor-page') &&
        !document.body.classList.contains('block-editor-iframe__body')
    ) {
        sliderStepInit();
    } else if (window.acf) {
        window.acf.addAction('render_block_preview/type=bn/slider-step', sliderStepInit);
    }
});
